import { address as mezoMainnetAddress } from "@mezo-org/mezod-contracts/deployments/mainnet/mswBTC.json"
import { address as mezoTestnetAddress } from "@mezo-org/mezod-contracts/deployments/testnet/mswBTC.json"
import { Address } from "viem"

import artifacts from "#/shared/utils/artifacts"

export default artifacts.getBridgeableERC20TokenArtifact({
  mainnetAddress: "0x8DB2350D78aBc13f5673A411D4700BCF87864dDE",
  testnetAddress: "0x2EE9f779850c8a31c7d77Af0B8d0c91AF2Ea25fB",
  mezoTestnetAddress: mezoTestnetAddress as Address,
  mezoMainnetAddress: mezoMainnetAddress as Address,
})
